import assign from 'lodash.assign';
export class Person {
    constructor(init) {
        assign(this, init);
    }
    firstName;
    familyName;
    birthDate;
    birthPlaceName;
    contact;
    residenceAddress;
}
